import React from 'react'
import GenericTable from 'components/Table/GenericTable'
import { defaultProps } from 'components/Table/AdminUsersTable/component'

export const AdminUsersTable = ({ data }) => {
  return <GenericTable {...defaultProps} rows={data} />
}
